( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'lesson-plan-slider', COMPONENT );
} )( app );
